if (!customElements.get('redefine-banner')) {
  customElements.define('redefine-banner', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      if (this.dataset.animate !== 'true' || reduced.matches) return;
      this.classList.add('is-ready');
      this.frame = requestAnimationFrame(() => {
        this.frame = requestAnimationFrame(() => this.classList.add('is-in'));
      });
      const update = () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          const rect = this.getBoundingClientRect();
          if (rect.bottom > 0 && rect.top < innerHeight) {
            this.style.setProperty('--hy', `${reduced.matches ? 0 : Math.max(0, -rect.top) * .22}px`);
          }
        });
      };
      window.addEventListener('scroll', update, {passive:true, signal:this.controller.signal});
      reduced.addEventListener('change', update, {signal:this.controller.signal});
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = null;
      this.classList.remove('is-ready', 'is-in');
      this.style.removeProperty('--hy');
    }
  });
}
